// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Kui","content":"styles_content__2LAMH"};